"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
/**
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingProfilerDumperText extends base_1.TwingProfilerDumperBase {
    formatTemplate(profile, prefix) {
        return `${prefix}└ ${profile.getTemplate()}`;
    }
    formatNonTemplate(profile, prefix) {
        return `${prefix}└ ${profile.getTemplate()}::${profile.getType()}(${profile.getName()})`;
    }
    formatTime(profile, percent) {
        return `${(profile.getDuration() * 1000).toFixed(2)}ms/${percent}%`;
    }
}
exports.TwingProfilerDumperText = TwingProfilerDumperText;
